import * as React from "react";

// style, design
import BaseTable from "src/components/Lists/Base/FinalTable/BaseTable";
import columnDefs from "./listDefs";

// store, state
import { constants, detailUrl } from "../../../../store/parkingLots";
import { useFilteredRealEstates } from "../../../../store/realEstates";

import { BADGE_TYPES } from "src/components/Badge/Badge";

export default function ParkingLotsTable({
  persistantQuery,
  isBare,
  ignoreLocalStorage,
  tableId,
  onRowClicked,
  checkRowHighlighted,
  onRowSelected,
}) {
  const [realEstates] = useFilteredRealEstates();

  const columns = React.useMemo(
    () => columnDefs(realEstates),
    [realEstates, persistantQuery]
  );

  const badges = {};
  const filters = {};

  return (
    <BaseTable
      tableId={tableId || "parkinglots_full_table"}
      title={"Parkeringsområden"}
      onRowClickedWithDetail={(obj) =>
        detailUrl({
          id: obj.id,
        })
      }
      {...{
        isBare,
        ignoreLocalStorage,
        onRowClicked,
        columns,
        persistantQuery,
        badges,
        filters,
        constants,
        checkRowHighlighted,
        onRowSelected,
      }}
    />
  );
}
